export default __webpack_public_path__ + "static/media/smartphone.487c7a08.png";